import { useTheme } from "@emotion/react";
import {
  ArrowForwardIosOutlined, // <- Adicionado para manter o padrão visual do Drawer
  Check,
  ClearOutlined,
  CreateOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Divider,
  Drawer, // <- Adicionado o import do Drawer
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import buscarClienteIdLocal from "../shared/clienteIdLocal";
import { StatusChipModal } from "../../../utils/chipsErp/chipStatusModal";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import AnexosTicketComponent from "../anexosTicketComponent";
import AnswerQuestionsComponent from "../answerQuestionsComponent";
import DescricaoTicketComponent from "../descricaoTicketComponent";
import EditTicketComponentIxc from "../editTicketComponentIxc";
import MensagensTicketComponent from "../mensagensTicketComponent";
import OrdemServiceIxcComponent from "../ordemServiceIxcComponent";
import ReportsComponent from "../reportsComponent";
import RfoComponent from "../rfoComponent";
import useStyles from "./styles";
import TimelineComponent from "../timelineComponent";

function htmlForText(html) {
  if (!html) return "";

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  function extrairTexto(node) {
    let texto = "";

    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        texto += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = child.tagName;

        switch (tag) {
          case "BR":
            texto += "\n";
            break;
          case "P":
          case "DIV":
            texto += extrairTexto(child) + "\n";
            break;
          case "LI":
            texto += "- " + extrairTexto(child) + "\n";
            break;
          case "UL":
          case "OL":
            texto += extrairTexto(child) + "\n";
            break;
          default:
            texto += extrairTexto(child);
        }
      }
    });

    return texto;
  }

  // Extrai texto e normaliza múltiplas quebras de linha
  const resultado = extrairTexto(tempDiv);
  return resultado.replace(/\n{3,}/g, "\n\n").trim();
}

export default function TicketModalContentIxc(params) {
  const {
    open, // <- Adicionado para controlar o Drawer
    loading, // <- Adicionado para controlar o spinner principal
    handleClose,
    erp,
    // Id do ERP escolhido na tela; vai no body das rotas (sem ele, o backend
    // usa a variável ERP).
    erpId,
    ticketDetails,
    labelTabsErp,
    value,
    handleChange,
    isEdit,
    setTicketDetails,
    itensPublic,
    setItensPublic,
    setSnackbar,
    setIsEditTicket = () => {},
    setEditedTicket = () => {},
    setIsEditOs = () => {},
    isEditOs = false,
    setIsNewOs = () => {},
    isNewOs = false,
    isEditTicket = false,
    // Esconde a ação do cabeçalho (editar).
    somenteLeitura = false,
    isCliente = false,
    isAtendimento = false,
    typeTitleModal = "Atendimento",
    configParamsErp = () => {},
    isOs = false,
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);
  // Nome resolvido no backend conforme a configuração de exibição do cliente.
  const nomeCliente = ticketDetails?.cliente?.nome || "";
  const [loadingParams, setLoadingParams] = useState(false);
  const [servicos, setServicos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [setores, setSetores] = useState([]);
  const [filiais, setFiliais] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [prioridadesOs, setPrioridadesOs] = useState([]);
  const [assuntos, setAssuntos] = useState([]);
  const [dataTicket, setDataTicket] = useState({});
  const [loadingLogins, setLoadingLogins] = useState(false);
  const [status, setStatus] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [logins, setLogins] = useState([]);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);

  const [error, setError] = useState(false);
  const [horarios, setHorarios] = useState([]);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [loadingServicos, setLoadingServicos] = useState(false);

  useEffect(() => {
    if (dataTicket?.clienteServicoId) {
      /*  getInfoClientNewTicket(); */
      getLoginsIxc();
    }
  }, [dataTicket?.clienteServicoId]);

  // Centraliza a lógica de interceptação de fechamento
  const handleCloseAttempt = () => {
    if (isEditTicket || isEditOs || isNewOs) {
      setConfirmacaoSaidaPagina(true);
    } else {
      handleClose();
    }
  };

  const handleCloseEditTicket = () => {
    setIsEditTicket(false);
    setConfirmacaoSaidaPagina(false);
    setDataTicket({});
  };
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  const editTicket = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });
      setError(true);
      return;
    }

    setLoadingCreateTicket(true);
    try {
      const response = await api.post("/interno/edit/ticket", {
        erpId,
        idAtendimento: ticketDetails?.id_atendimento,
        dataTicket: dataTicket,
      });
      setTicketDetails(response?.data);

      setIsEditTicket(false);
      setEditedTicket(true); //NECESSÁRIO PARA MONITORAR FORA DO COMPONENTE SE TEVE ATUALIZAÇÃO
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Ocorreu um erro ao editar o atendimento",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };

  const editOs = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });
      setError(true);
      return;
    }

    setLoadingCreateTicket(true);
    try {
      const response = await api.post("/interno/edit/os", {
        erpId,
        idOs: ticketDetails?.id_atendimento,
        dataOs: dataTicket,
      });
      setTicketDetails(response?.data);

      setIsEditTicket(false);
      setEditedTicket(true);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Ocorreu um erro ao editar o atendimento",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };

  const getServicos = async () => {
    try {
      setLoadingServicos(true);
      const response = await api.post("/interno/find/allServiceClient", {
        idClienteErp: ticketDetails?.cliente?.codigo_cliente?.toString(),
        clienteId: await buscarClienteIdLocal(
          ticketDetails?.cliente?.codigo_cliente,
          erpId,
        ),
      });
      setServicos(response?.data);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };

  const getLoginsIxc = async () => {
    setLoadingLogins(true);
    try {
      const response = await api.post("/interno/find/loginsIxc", {
        idContrato: dataTicket?.clienteServicoId,
        erpId,
      });
      setLogins(response?.data);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingLogins(false);
    }
  };

  const getParamsEditTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.post("/interno/find/paramsNewTicket", {
        erpId,
      });

      setFiliais(response?.data?.filiais || []);
      setAssuntos(response?.data?.assuntos || []);
      setDepartamentos(response?.data?.departamentos || []);
      setSetores(response?.data?.setores || []);
      setPrioridades(response?.data?.prioridades || []);
      setPrioridadesOs(response?.data?.prioridadesOsIxc || []);
      setStatus(response?.data?.status || []);
      setStatusOs(response?.data?.statusOsIxc || []);
      setHorarios(response?.data?.horarios || []);

      setDataTicket({
        clienteErpId: ticketDetails?.cliente?.codigo_cliente,
        nome: nomeCliente || null,
        clienteServicoId: ticketDetails?.clienteServicoId,
        loginId: ticketDetails?.loginId,
        filialId: ticketDetails?.filial?.id,
        origem_endereco: ticketDetails?.origemEndereco,
        assuntoId: ticketDetails?.id_assunto,
        titulo: ticketDetails?.assunto,
        departamentoId: ticketDetails?.setorId,
        prioridadeId: ticketDetails?.prioridadeId,
        horarioId: ticketDetails?.horario,
        descricaoAbertura: ticketDetails?.descricao_abertura,
        responsavelId: ticketDetails?.id_usuario_abertura,
        statusId: ticketDetails?.status?.id,
        protocolo: ticketDetails?.protocolo,
        endereco: ticketDetails?.cliente?.endereco_instalacao,
      });
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };

  const handleEditTicket = () => {
    setIsEditTicket(true);
    getServicos();
    getParamsEditTicket();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleCloseAttempt}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      PaperProps={{
        sx: {
          width: "80%",
          maxWidth: "80%",
        },
      }}
    >
      {loading ? (
        <Box sx={styles.containerModal}>
          <Box sx={styles.conatinerLoading}>
            <CircularProgress />
          </Box>
        </Box>
      ) : (
        <Box sx={{ ...styles.containerModal }}>
          {isEditTicket ? (
            <>
              {loadingParams ? (
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box
                  sx={{
                    height: "700px",
                    overflow: "hidden",
                    padding: "0 40px",
                  }}
                >
                  <Box sx={{ padding: "20px 0" }}>
                    <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                      Editar {isOs ? "OS" : "Atendimento"} - Protocolo{" "}
                      {ticketDetails?.protocolo}
                    </Typography>
                  </Box>
                  <EditTicketComponentIxc
                    erpId={erpId}
                    loadingServicos={loadingServicos}
                    loadingCreateTicket={loadingCreateTicket}
                    loadingParams={loadingParams}
                    setServicos={setServicos}
                    servicos={servicos}
                    setDataTicket={setDataTicket}
                    dataTicket={dataTicket}
                    error={error}
                    logins={logins}
                    filiais={filiais}
                    departamentos={departamentos}
                    setores={setores}
                    assuntos={assuntos}
                    status={status}
                    statusOs={statusOs}
                    prioridades={prioridades}
                    prioridadesOs={prioridadesOs}
                    horarios={horarios}
                    loadingLogins={loadingLogins}
                    isEdit={true}
                    isOs={isOs}
                  />
                  <Box sx={styles.containerButtonEdit}>
                    <Button
                      disabled={loadingCreateTicket}
                      onClick={() => {
                        setConfirmacaoSaidaPagina(true);
                      }}
                      size="small"
                    >
                      Cancelar
                    </Button>
                    <LoadingButton
                      onClick={() => (isOs ? editOs() : editTicket())}
                      size="small"
                      loading={loadingCreateTicket}
                      variant="contained"
                    >
                      Salvar
                    </LoadingButton>
                  </Box>
                </Box>
              )}
            </>
          ) : (
            <>
              {/* Cabeçalho */}
              <Box sx={styles.containerHeaderModal}>
                <Box sx={styles.containerIconExist}>
                  <IconButton
                    onClick={handleCloseAttempt}
                    sx={{ margin: "5px" }}
                  >
                    <ArrowForwardIosOutlined sx={styles.clearIcon} />
                  </IconButton>
                </Box>

                <Tooltip
                  title={
                    (erp === "HUBSOFT" &&
                      `Atendimento - ${ticketDetails?.protocolo || ""} - (${
                        ticketDetails?.cliente?.codigo_cliente || ""
                      }) ${nomeCliente}`) ||
                    (erp === "VOALLE" && ticketDetails?.geral?.title) ||
                    (erp === "IXC" &&
                      `${typeTitleModal} - ${ticketDetails?.protocolo || ""} - (${
                        ticketDetails?.cliente?.codigo_cliente || ""
                      }) ${nomeCliente}`)
                  }
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={styles.titleModal}
                  >
                    {erp === "HUBSOFT" &&
                      `Atendimento - ${ticketDetails?.protocolo || ""} - (${
                        ticketDetails?.cliente?.codigo_cliente || ""
                      }) ${nomeCliente}`}
                    {erp === "VOALLE" && ticketDetails?.geral?.title}
                    {erp === "IXC" &&
                      `${typeTitleModal} - ${ticketDetails?.protocolo || ""} - (${
                        ticketDetails?.cliente?.codigo_cliente || ""
                      }) ${nomeCliente}`}
                  </Typography>
                </Tooltip>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: 1,
                    justifyContent: "space-between",
                  }}
                >
                  {/* Chips de status e tipo */}
                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    {erp === "HUBSOFT" &&
                      ticketDetails?.status?.descricao &&
                      StatusChipModal(ticketDetails?.status?.descricao)}
                    {erp === "VOALLE" &&
                      ticketDetails?.geral?.status &&
                      StatusChipModal(ticketDetails?.geral?.status)}
                    {erp === "IXC" &&
                      ticketDetails?.status?.descricao &&
                      StatusChipModal(ticketDetails?.status?.descricao)}

                    {erp === "HUBSOFT" && ticketDetails?.tipo_atendimento && (
                      <Tooltip title={ticketDetails?.tipo_atendimento}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.tipo_atendimento}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}
                    {erp === "IXC" && ticketDetails?.tipo_atendimento && (
                      <Tooltip title={ticketDetails?.tipo_atendimento}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.tipo_atendimento}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}

                    {erp === "VOALLE" && ticketDetails?.geral?.service && (
                      <Tooltip title={ticketDetails?.geral?.service}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.geral?.service}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}
                  </Box>
                  <Box>
                    <Box sx={{}}>
                      {!isCliente &&
                        !somenteLeitura &&
                        ticketDetails?.status?.id !== "C" &&
                        ticketDetails?.status?.id !== "S" &&
                        ticketDetails?.status?.id !== "F" && (
                          <ButtonGroup
                            size="small"
                            variant={
                              theme.palette.mode === "dark"
                                ? "outlined"
                                : "contained"
                            }
                          >
                            <Button
                              onClick={() => handleEditTicket()}
                              endIcon={<CreateOutlined />}
                            >
                              Editar
                            </Button>
                          </ButtonGroup>
                        )}
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Abas */}
              <Box sx={styles.containerTabs}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable tabs"
                  allowScrollButtonsMobile
                >
                  <Tab value={0} label={labelTabsErp.descricao} />
                  <Tab
                    value={1}
                    label={`${labelTabsErp.mensagens}${
                      ticketDetails?.atendimento_mensagem?.length > 0
                        ? ` (${ticketDetails?.atendimento_mensagem?.length})`
                        : ticketDetails?.reports?.length > 0
                          ? ` (${ticketDetails?.reports?.length})`
                          : ""
                    }`}
                  />
                  {erp === "HUBSOFT" && (
                    <Tab
                      value={2}
                      label={`Anexos${
                        ticketDetails?.anexos?.length > 0
                          ? ` (${ticketDetails?.anexos?.length})`
                          : ""
                      }`}
                    />
                  )}
                  {(erp === "HUBSOFT" || (erp === "IXC" && isAtendimento)) && (
                    <Tab
                      value={3}
                      label={`Ordem de serviço${
                        ticketDetails?.ordem_servico?.length > 0
                          ? ` (${ticketDetails?.ordem_servico?.length})`
                          : ""
                      }`}
                    />
                  )}
                  {isCliente && (
                    <Tab
                      value={5}
                      disabled={ticketDetails?.avaliacao?.length === 0}
                      label={"Avaliação"}
                    />
                  )}
                  {erp === "HUBSOFT" && (!isCliente || ticketDetails?.rfo) && (
                    <Tab value={4} label="RFO" />
                  )}
                  {(erp === "HUBSOFT" || erp === "IXC") && !isCliente && (
                    <Tab
                      value={6}
                      label={`Linha do tempo${
                        ticketDetails?.historicoFluxoAtendimento?.length > 0
                          ? ` (${ticketDetails?.historicoFluxoAtendimento?.length})`
                          : ""
                      }`}
                    />
                  )}
                </Tabs>
              </Box>

              <Divider />

              {/* Conteúdo das Abas */}
              {value === 0 && (
                <DescricaoTicketComponent
                  configParamsErp={configParamsErp}
                  ticketDetails={ticketDetails}
                  erp={erp}
                  isOsIxc={isOs}
                />
              )}

              {value === 1 && (erp === "HUBSOFT" || erp === "IXC") && (
                <MensagensTicketComponent
                  erp={erp}
                  erpId={erpId}
                  isEdit={isEdit}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  itensPublic={itensPublic}
                  setItensPublic={setItensPublic}
                  isCliente={isCliente}
                />
              )}

              {value === 1 && erp === "VOALLE" && (
                <ReportsComponent
                  reports={ticketDetails?.reports || []}
                  htmlForText={htmlForText}
                />
              )}

              {value === 2 && (
                <AnexosTicketComponent
                  erp={erp}
                  erpId={erpId}
                  ticketDetails={ticketDetails}
                  isEdit={isEdit}
                  setTicketDetails={setTicketDetails}
                  itensPublic={itensPublic}
                  setItensPublic={setItensPublic}
                />
              )}

              {value === 3 && (
                <OrdemServiceIxcComponent
                  erpId={erpId}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  isEdit={isEdit}
                  setOpenEditOS={setIsEditOs}
                  openEditOS={isEditOs}
                  setOpenNewOs={setIsNewOs}
                  openNewOs={isNewOs}
                  setSnackbar={setSnackbar}
                />
              )}

              {value === 4 && (
                <RfoComponent
                  erpId={erpId}
                  isEdit={isEdit}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  setSnackbar={setSnackbar}
                  setItensPublic={setItensPublic}
                  itensPublic={itensPublic}
                />
              )}
              {value === 5 && (
                <AnswerQuestionsComponent ticketDetails={ticketDetails} />
              )}
              {value === 6 && erp === "IXC" && (
                <TimelineComponent
                  erp={erp}
                  ticketDetails={ticketDetails}
                  isOsIxc={isOs}
                />
              )}
            </>
          )}
          <InternoModalConfirmacaoSaida
            openConfirmacao={confirmacaoSaidaPagina}
            confirmLoad={false}
            setOpenConfirmacao={setConfirmacaoSaidaPagina}
            execute={handleCloseEditTicket}
            cancel={handleCancelNavigation}
            severity={"warning"}
            title={"Atenção"}
            contentText={
              "As alterações não salvas serão perdidas, deseja continuar?"
            }
            headerText={"Você está prestes a sair do modo de edição."}
            confirmText={"Continuar"}
          />
        </Box>
      )}
    </Drawer>
  );
}
